import script from "./admin-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin-menu.vue?vue&type=script&setup=true&lang=ts"

import "./admin-menu.vue?vue&type=style&index=0&id=ab4317b0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab4317b0"]])

export default __exports__